module.exports = __webpack_public_path__ + "img/product-placeholder-59.8286646.png";